import * as IoC from 'typescript-ioc';
import { IAIFeatureDAO, IGenerateMeetingsDataParams, IGeneratePassportBackgroundMessageParams, IMeetingGenerationIdentifierResponse, IUrlRequestParams } from '../ai-feature.dao';
import { IApiClient } from '../../infrastructure/api-client';
import * as AI_FEATURE_API from '../../constants/api/ai-feature.constants';

class AIFeatureDAO extends IAIFeatureDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }
    public async generatePassportBackground(params: IGeneratePassportBackgroundMessageParams): Promise<void> {
        await this.apiClient.post<IGeneratePassportBackgroundMessageParams>(AI_FEATURE_API.GENERATE_PASSPORT_BACKGROUND, params);
    }
    public async getMeetingsGenerationIdentifier(params: IUrlRequestParams): Promise<IMeetingGenerationIdentifierResponse> {
        const response = await this.apiClient.get<IMeetingGenerationIdentifierResponse>(AI_FEATURE_API.GET_GENERATE_MEETINGS_IDENTIFIER, params);
        return response.parsedResponse;
    }
    public async generateMeetingsData(params: IGenerateMeetingsDataParams): Promise<void> {
        await this.apiClient.post<IGenerateMeetingsDataParams>(AI_FEATURE_API.GENERATE_MEETINGS_DATA, params);
    }
}

export { AIFeatureDAO };